import _Row from "antd/es/row";
import _Col from "antd/es/col";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _Form from "antd/es/form";
import _Checkbox from "antd/es/checkbox";
import React, { Component } from 'react';
import { css, cx } from 'emotion';
import { optionContentRender } from './SingleChoice';
import { getLocalText } from '@/utilities/language';
import MultiChoice from '../../common/Question/MultiChoice';
import InputSingleLine from './InputSingleLine';
import { getMultiChoiceOptions } from '@/utilities/quest';
var CheckboxGroup = _Checkbox.Group;
var FormItem = _Form.Item;
var MultiChoicePC = /*#__PURE__*/function (_Component) {
  _inherits(MultiChoicePC, _Component);
  function MultiChoicePC() {
    _classCallCheck(this, MultiChoicePC);
    return _possibleConstructorReturn(this, _getPrototypeOf(MultiChoicePC).apply(this, arguments));
  }
  _createClass(MultiChoicePC, [{
    key: "renderMultiChoiceOpts",
    value: function renderMultiChoiceOpts(_ref) {
      var id = _ref.id,
        options = _ref.options,
        rowCounts = _ref.rowCounts,
        colsSpan = _ref.colsSpan,
        splitCols = _ref.splitCols,
        disabledOptIds = _ref.disabledOptIds,
        overDisabledIds = _ref.overDisabledIds,
        error = _ref.error,
        onChange = _ref.onChange,
        formAnswer = _ref.formAnswer;
      return new Array(rowCounts).fill('').map(function (_, i) {
        return React.createElement(_Row, {
          gutter: 16,
          className: wrapperCol,
          key: id.concat(i)
        }, options.slice(i * splitCols, splitCols * (i + 1)).map(function (option) {
          return React.createElement(_Col, {
            span: colsSpan,
            key: option.id
          }, React.createElement(_Checkbox, {
            key: option.id,
            disabled: option.disabled || Boolean(disabledOptIds.find(function (id) {
              return id === option.id;
            })) || Boolean(overDisabledIds.find(function (id) {
              return id === option.id;
            })),
            className: checkboxCls,
            value: option.id
          }, optionContentRender({
            option: option,
            error: error,
            onChange: onChange,
            formAnswer: formAnswer
          })));
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        label = _this$props.label,
        question = _this$props.question;
      return React.createElement(MultiChoice, this.props, function (_ref2) {
        var _ref2$options = _ref2.options,
          options = _ref2$options === void 0 ? [] : _ref2$options,
          error = _ref2.error,
          _onChange = _ref2.onChange,
          formAnswer = _ref2.formAnswer,
          disabledOptIds = _ref2.disabledOptIds,
          overDisabledIds = _ref2.overDisabledIds,
          min = _ref2.min,
          max = _ref2.max,
          realMin = _ref2.realMin,
          realMax = _ref2.realMax;
        var selected = error.selected,
          text = error.text;
        var _question$custom = question.custom,
          _question$custom$spli = _question$custom.splitCols,
          splitCols = _question$custom$spli === void 0 ? 1 : _question$custom$spli,
          group = _question$custom.group,
          optionGroups = _question$custom.optionGroups,
          other = _question$custom.other,
          required = question.required,
          id = question.id;
        var opts = getMultiChoiceOptions({
          options: options,
          custom: question.custom
        });
        var rowCounts = Math.ceil(opts.length / splitCols); // default to options.length
        var colsSpan = Math.ceil(24 / splitCols); // default to 24
        var lng = window.language || 'cn';
        // const params = {
        //   id,
        //   options: opts,
        //   rowCounts,
        //   colsSpan,
        //   splitCols,
        //   disabledOptIds,
        //   overDisabledIds,
        //   error,
        //   onChange,
        //   formAnswer,
        // };
        return React.createElement(FormItem, {
          label: label,
          validateStatus: selected || text ? 'error' : null,
          hasFeedback: true,
          help: selected || text,
          required: required
        }, React.createElement(CheckboxGroup, {
          value: formAnswer.selected,
          onChange: function onChange(selected) {
            return _onChange.selected(selected, formAnswer);
          },
          className: "".concat("allWidth" + ' ').concat(MultiChoiceGroupCls)
        }, group && (optionGroups === null || optionGroups === void 0 ? void 0 : optionGroups.length) ? opts.map(function (opt) {
          rowCounts = Math.ceil(opt.options.length / splitCols);
          return React.createElement("div", {
            className: "optGroup"
          }, opt.showGroupName && React.createElement("div", {
            className: "groupName"
          }, React.createElement("span", {
            className: "icon"
          }, lng === 'cn' ? '分组' : 'group'), opt.name), _this.renderMultiChoiceOpts({
            id: id,
            options: opt.options,
            rowCounts: rowCounts,
            colsSpan: colsSpan,
            splitCols: splitCols,
            disabledOptIds: disabledOptIds,
            overDisabledIds: overDisabledIds,
            error: error,
            onChange: _onChange,
            formAnswer: formAnswer
          }));
        }) : _this.renderMultiChoiceOpts({
          id: id,
          options: opts,
          rowCounts: rowCounts,
          colsSpan: colsSpan,
          splitCols: splitCols,
          disabledOptIds: disabledOptIds,
          overDisabledIds: overDisabledIds,
          error: error,
          onChange: _onChange,
          formAnswer: formAnswer
        }), other.status > 0 && React.createElement(_Col, {
          span: colsSpan,
          className: wrapperCol
        }, React.createElement(_Checkbox, {
          className: cx(checkboxCls, 'allWidth'),
          value: "other"
        }, React.createElement("div", {
          className: error.errorOption === 'other' && 'option-error'
        }, getLocalText('placeholder.other'), React.createElement(InputSingleLine, {
          placeholder: other.placeholder || '',
          value: formAnswer.text,
          onChange: function onChange(e) {
            return _onChange.text(e.target.value);
          },
          required: other.status === 2,
          chosen: formAnswer.selected.includes('other'),
          id: "other".concat(id.replace('$', ''))
        }))))), Boolean(realMin || realMax) && lng === 'cn' && React.createElement("div", {
          style: {
            fontSize: 12
          }
        }, "* ", getLocalText('MultiChoice.min.or.max', min, max)));
      });
    }
  }]);
  return MultiChoicePC;
}(Component);
export { MultiChoicePC as default };
var MultiChoiceGroupCls = /*#__PURE__*/css(".ant-checkbox-wrapper-disabled{.ant-checkbox-disabled{opacity:0.3;}.ant-checkbox-inner{background:var(--checkbox-disabled-color) !important;border-color:var(--checkbox-disabled-color) !important;}.allWidth{color:var(--checkbox-disabled-color) !important;}}.optGroup{width:100%;margin-bottom:24px;.groupName{margin:8px 0 -8px;font-size:12px;color:var(--text-color);.icon{padding:4px;margin-right:6px;border-radius:4px;background:#f8f8f8;font-size:12px;color:rgba(22,24,35,0.75);}}.optGroupItem{width:100%;display:flex;flex-wrap:wrap;}}");
var wrapperCol = /*#__PURE__*/css("margin-top:26px;&:first-of-type{margin-top:0;}");
var checkboxCls = /*#__PURE__*/css("display:flex;margin-left:0;.ant-checkbox{display:flex;align-items:flex-start;height:19px;width:19px;}& + &{margin-left:0;}.ant-input{border-color:var(--border-gray);}.option-error .ant-input{border-color:var(--text-red);}.ant-checkbox + span{display:inline-block;margin-top:-3px;padding-left:16px;}&.ant-checkbox-wrapper-checked{color:var(--primary-color);}span{width:100%;}");